import mutations from './impactAssessment.mutations'
import actions from './impactAssessment.actions'
import getters from './impactAssessment.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
